import { Link } from "react-router-dom";
import footerMenu from "./footerMenu";

const CFooter = (props) => {
  const fm1 = footerMenu[0].footerMenu1;
  const fm2 = footerMenu[0].footerMenu2;
  const navFixed = props.navFixed === undefined ? "" : props.navFixed;
  const copyRight =
    props.copyRight === undefined ? (
      <>
        <span>Ⓒ 2022 Next Health Media LLC.</span>
        <br />
        <span>All Rights Reserved</span>
      </>
    ) : (
      props.copyRight
    );
  const customStyle =
    props.customStyle === undefined
      ? { backgroundColor: "#044389", color: "white" }
      : props.customStyle;
  const fw =
    props.fontWeight === undefined ? "fw-bold" : `fw-${props.fontWeight}`;

  const menuAlignment =
    props.menuAlignment === "center"
      ? "text-center"
      : props.menuAlignment === "left"
      ? "text-start"
      : props.menuAlignment === "right"
      ? "text-end"
      : "";

  const copyRightTextAlignment =
    props.copyRightTextAlignment === "center"
      ? "text-center"
      : props.copyRightTextAlignment === "left"
      ? "text-start"
      : props.copyRightTextAlignment === "right"
      ? "text-end"
      : "";

  const copyRightBlockAlignment =
    props.copyRightBlockAlignment === "left"
      ? "float-start"
      : props.copyRightBlockAlignment === "right"
      ? "float-end"
      : "";

  return (
    <>
      <div className={`container-fluid fixed-${navFixed}`} style={customStyle}>
        <div className="row p-4">
          <div className={`col-md-8 col-sm-12 ${menuAlignment}`}>
            <div className="row row-cols-md-5 row-cols-sm-1 mb-3">
              <div className={`${fw}`}>{fm1.title}</div>
              {fm1.menu.map((item, index) => (
                <div>
                <Link
                  to={item.value}
                  className="text-decoration-none text-light"
                >
                  {item.label}
                </Link>
              </div>
              ))}
            </div>
            <div className="row row-cols-md-5 row-cols-sm-1">
              <div className={`${fw}`}>{fm2.title}</div>
              {fm2.menu.map((item, index) => (
                <div>
                  <Link
                    to={item.value}
                    className="text-decoration-none text-light"
                  >
                    {item.label}
                  </Link>
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-4 col-sm-12 text-sm-center">
            <span
              className={copyRightBlockAlignment + " " + copyRightTextAlignment}
            >
              {copyRight}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default CFooter;
